import React, { Component } from "react";
import { Navbar, Nav, Spinner, NavDropdown } from "react-bootstrap";
import { dashboard } from "../../images";
import { connect } from "react-redux";
import { accountLogout } from "../../store/actions/KeycloakActions";

import Gravatar from "react-gravatar";
import { toastr } from "react-redux-toastr";
import history from "../../history";

import { Link } from "react-router-dom";

class AppNavBar extends Component {
  renderUserDetail() {
    if (this.props.allowDetailDisplay) {
      return <React.Fragment>{this.props.tokenDetail.name}</React.Fragment>;
    } else {
      return (
        <Spinner className="m-1" size="sm" variant="dark" animation="border" />
      );
    }
  }

  redirectToDashboard() {
    window.location.href =
      window.location.hostname === "localhost" ? "/" : "/pawnshop-reports/";
  }

  render() {
    const toastrConfirmOptions = {
      okText: "Yes",
      cancelText: "No",
      onOk: () => this.props.Logout(),
      onCancel: () => {},
    };
    return (
      <React.Fragment>
        <Navbar
          expand="lg"
          bg="dark"
          variant="dark"
          sticky="top"
          className="shadow"
        >
          <Navbar.Brand onClick={this.redirectToDashboard}>
            <img
              alt=""
              src={dashboard}
              width="30"
              height="30"
              className="d-inline-block align-top mr-2"
            />
            <span>
              <span>Pawnshop</span>
              <span className="strong"> Executive Dashboard</span>
            </span>
          </Navbar.Brand>
          <Navbar.Text>{process.env.REACT_APP_VERSION}</Navbar.Text>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav>{/* content here */}</Nav>
            <Nav className="mr-auto" />
            <Nav className="mr-4">
              <a className="nav-link" onClick={this.redirectToDashboard}>
                Dashboard
              </a>
              <Link className="nav-link" to="/pawnshop-reports/reports">
                Reports
              </Link>
              <Link className="nav-link" to="/pawnshop-reports/settings">
                Settings
              </Link>
            </Nav>
            <Nav as="button" className="btn text-light">
              <Navbar.Text>
                <Gravatar
                  height="25"
                  width="25"
                  email={this.props.tokenDetail.email}
                />
              </Navbar.Text>
              <NavDropdown
                title={this.renderUserDetail()}
                id="collasible-nav-dropdown"
              >
                <NavDropdown.Item
                  onClick={() => {
                    toastr.confirm(
                      "Are you sure you want to leave?",
                      toastrConfirmOptions
                    );
                  }}
                >
                  Logout
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    tokenDetail: state.keycloak.tokenDetails,
    allowDetailDisplay: state.keycloak.allowedToDisplayDetails,
  };
};

const mapDispatchToProps = {
  Logout: accountLogout,
};

export default connect(mapStateToProps, mapDispatchToProps)(AppNavBar);
